<template>
    <svg data-testid="click-to-add" aria-hidden="true" fill="currentColor" class="___12fm75w f1w7gpdv fez10in fg4l7m0"
        width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 2.5a.5.5 0 0 0-1 0V9H2.5a.5.5 0 0 0 0 1H9v6.5a.5.5 0 0 0 1 0V10h6.5a.5.5 0 0 0 0-1H10V2.5Z"
            fill="currentColor"></path>
    </svg>
</template>
